
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 19H2.643C1.735 19 1 18.105 1 17V3c0-1.105.735-2 1.643-2H13.32c.908 0 1.643.895 1.643 2v6.5","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","d":"M5.75 5.25h4.5"}}),_c('path',{attrs:{"d":"M7.734 9.676l-.241.53h-3.3l.197-.53h3.344zm-.46 1.027l-.256.537H4.194l.196-.537h2.884zM8.36 8.322l-.348.74a2.408 2.408 0 00-.27-.183 1.674 1.674 0 00-.336-.15 1.3 1.3 0 00-.403-.06 1.12 1.12 0 00-.654.197c-.189.13-.337.327-.445.592-.106.263-.159.597-.159 1.002 0 .404.053.738.16 1.001.107.264.255.46.444.587.189.127.407.191.654.191.146 0 .28-.019.403-.057.122-.038.232-.086.33-.144.1-.058.185-.116.256-.174l.353.74c-.177.155-.382.27-.614.349-.23.078-.473.117-.728.117-.424 0-.8-.104-1.129-.311a2.113 2.113 0 01-.768-.898c-.185-.39-.278-.858-.278-1.402 0-.545.093-1.013.278-1.404a2.11 2.11 0 01.768-.9c.328-.21.705-.316 1.129-.316a2.1 2.1 0 011.357.483z","fill":"#363636"}}),_c('path',{attrs:{"d":"M11 13.408a1.818 1.818 0 011.846-1.405 1.78 1.78 0 011.876 1.667c0 1.254-1.793 1.668-1.793 2.501M12.93 18.36c.057 0 .104.046.104.104","stroke":"#D07D01","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    